import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { Button } from '@/components/shadcn/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useChat } from './hooks'
import clsx from 'clsx'

export function ConfirmClearDialog() {
  const { clearChat, messages } = useChat()
  return (
    <ConfirmDialog
      trigger={
        <Button
          variant="secondary"
          size="sm"
          disabled={messages.length === 0}
          // className="text-gray-600 hover:border-red-300 hover:text-red-600"
          className={clsx('rounded-l-full rounded-r-full', messages.length === 0 && 'invisible')}
        >
          <IconDeleteOutline size={16} />
          <span className="ml-2 font-light">Start a new chat</span>
        </Button>
      }
      title="Clear Chat"
      description="The chat history will be wiped and cannot be recovered. Are you sure you want to clear the chat?"
      onConfirm={() => {
        clearChat()
      }}
      closeOnConfirm={true}
    />
  )
}
